module.exports = __webpack_public_path__ + "assets/places2_white.7a107bdb.svg";